import React from 'react';
import { Row, Col, Typography, Button } from 'antd';
import { motion } from 'framer-motion';
import './ContactBanner.css';

const { Title, Paragraph } = Typography;

const ContactBanner = () => {
  return (
    <div className="contact-banner" style={{ 
      padding: '60px 0', 
      background: 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)',
      color: 'white',
      margin: '50px 0'
    }}>
      <Row justify="center">
        <Col xs={24} md={16} style={{ textAlign: 'center' }}>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <Title level={2} style={{ color: 'white' }}>Ready to Transform Your Healthcare Facility?</Title>
            <Paragraph style={{ fontSize: '1.1rem', color: 'rgba(255,255,255,0.9)' }}>
              Contact us today for a free initial consultation with our Prime Health Care experts.
            </Paragraph>
            <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
              <a href="/contact">
              <Button 
                type="primary" 
                size="large" 
                style={{ 
                  background: 'white', 
                  color: '#1890ff', 
                  fontWeight: 'bold',
                  marginTop: '20px'
                }}
              >
                Get in Touch
              </Button>
              </a>
            </motion.div>
          </motion.div>
        </Col>
      </Row>
    </div>
  );
};

export default ContactBanner;